import TableProjects from "../../components/Table/TableProjects";

const Projects = () => {
  return (
    <>
      <TableProjects />
    </>
  );
};

export default Projects;
